import { EMPTY } from 'rxjs';
import { matchPath } from 'react-router-dom';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { markupProfileListSelector, MarkupProfileAction } from '@cbridge-packages/markup-profile';
import { RouterAction, locationSelector, withSkipUnsavedChangesConfirmation } from '@cbridge-packages/routing';
import { generateMarkupRoute } from '@cbridge-packages/routing-client-admin';

type IState =
  & IGetSelectorStateType<typeof locationSelector>
  & IGetSelectorStateType<typeof markupProfileListSelector>;

export const closeMarkupBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(MarkupProfileAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { profileId } = payload;
    const { pathname } = locationSelector(state);
    const isCurrentProfile = matchPath({ path: generateMarkupRoute(profileId), end: false }, pathname);

    if (!isCurrentProfile) {
      return EMPTY;
    }

    const { list } = markupProfileListSelector(state);
    const firstProfile = list.find((p) => p.markupProfileId !== profileId);

    const route = firstProfile
      ? generateMarkupRoute(firstProfile.markupProfileId)
      : generateMarkupRoute();

    return [RouterAction.replace([route, withSkipUnsavedChangesConfirmation()])];
  }),
);
